import { dependencies } from "../dependencies";
import { IModelInfo } from "./IModelInfo";
import { IModelInfoService } from "./IModelInfoService";

export class ModelInfoService implements IModelInfoService {
    get(): Promise<IModelInfo[]> {
        return dependencies.modelInfoRepository.get();
    }
    getById(id: string): Promise<IModelInfo | undefined> {
        return dependencies.modelInfoRepository.getById(id);
    }
    save(items: IModelInfo[]): Promise<void> {
        return dependencies.modelInfoRepository.save(items);
    }
    delete(id: string): Promise<void> {
        return dependencies.modelInfoRepository.delete(id);
    }
    deleteAll(): Promise<any> {
        return dependencies.modelInfoRepository.deleteAll();
    }
}
